import React, { useEffect } from 'react';

import { AvatarItem } from '@atlaskit/avatar';
import AvatarGroup, { AvatarProps } from '@atlaskit/avatar-group';
import PeopleGroupIcon from '@atlaskit/icon/glyph/people-group';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

import { getAvatarUrl, getName } from 'src/components/user-profile';
import { useParams } from 'src/router/hooks';

import * as styles from '../reviewer-statuses-card/reviewer-status.style';

import { useReviewGroupsActions } from './provider';
import { ReviewGroupsContainer } from './styled';
import { ReviewGroup } from './types';

const getAvatarGroupData = (group: ReviewGroup) => {
  const members: Array<AvatarProps> = group.members.map(member => ({
    key: member.account_id,
    src: getAvatarUrl(member),
    name: getName(member),
    size: 'small',
    status:
      group.approvers.find(
        approver => approver.account_id === member.account_id
      ) && 'approved',
  }));
  members.unshift({
    key: group.label,
    name: group.label,
    size: 'small',
    status: group.has_approved && 'approved',
    children: props => (
      <span
        {...props}
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: token('color.background.neutral'),
        }}
      >
        <PeopleGroupIcon label={group.label} />
      </span>
    ),
  });
  return members;
};

export const ReviewGroups = (): React.ReactElement | null => {
  const { repositoryOwner, repositorySlug, pullRequestId } = useParams<{
    repositoryOwner: string;
    repositorySlug: string;
    pullRequestId: string;
  }>();

  const [{ isLoading, reviewGroups }, { fetchReviewGroups }] =
    useReviewGroupsActions();

  useEffect(() => {
    fetchReviewGroups(repositoryOwner, repositorySlug, pullRequestId);
  }, [repositoryOwner, repositorySlug, pullRequestId, fetchReviewGroups]);

  if (isLoading) {
    return <Spinner size="small" />;
  }

  return reviewGroups?.length > 0 ? (
    <ReviewGroupsContainer>
      {reviewGroups.map((group: ReviewGroup) => (
        <styles.ReviewerStatusContainer key={group.label} tabIndex={0}>
          <styles.BackgroundContainer>
            <AvatarItem
              avatar={
                // TODO maxCount?
                <AvatarGroup data={getAvatarGroupData(group)} maxCount={2} />
              }
              primaryText={`${group.label} (${group.approvers.length}/${group.required_count})`}
            />
          </styles.BackgroundContainer>
        </styles.ReviewerStatusContainer>
      ))}
    </ReviewGroupsContainer>
  ) : null;
};
